const formatNumReporte = (numeroReporte) => {
  //agrega al numero recibido el numero de ceros que falten para completar 6 digitos
  const numberString = numeroReporte.toString();
  const zerosNeeded = 6 - numberString.length;
  const zeros = "0".repeat(zerosNeeded);
  return zeros + numberString;
};

export default formatNumReporte;
